"use strict";

exports.__esModule = true;
var _Footer = require("./Footer");
exports.Footer = _Footer.Footer;